import { FormControl } from 'baseui/form-control'
import { KIND, SIZE } from 'baseui/button'
import SDInput from '@/shared/components/SDComponents/SDInput/SDInput'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { OuterContainer, Block } from '../styled-components'
import useComparatorAdd from './useComparatorAdd'
import { Header1 } from '@/shared/theme/styled-components'

const ComparatorAdd = () => {
  const { t, name, error, save, handleNameChange, handleSave, handleCancel, isSelectraAdmin } = useComparatorAdd()

  if (!isSelectraAdmin) {
    return (
      <OuterContainer>
        <Block>{t('comparator.unauthorized')}</Block>
      </OuterContainer>
    )
  }

  return (
    <OuterContainer>
      <Block>
        <Header1>{t('comparator.add_title')}</Header1>
        <FormControl label={t('name')} error={error}>
          <SDInput error={error} value={name} onChange={handleNameChange} />
        </FormControl>
        <SDButton onClick={handleSave} size={SIZE.compact} kind={KIND.primary} isLoading={save.loading}>
          {t('comparator.save_btn')}
        </SDButton>
        <SDButton onClick={handleCancel} size={SIZE.compact} kind={KIND.tertiary}>
          {t('common:cancel')}
        </SDButton>
      </Block>
    </OuterContainer>
  )
}

export default ComparatorAdd
